import { configureStore, combineReducers } from "@reduxjs/toolkit"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import testReducer from "./src/slices/testSlice"
import hazardReducer from "./src/slices/hazardSlice"
import authReducer from './src/slices/authSlice'

const rootReducer = combineReducers({
  test: testReducer,
  hazard: hazardReducer,
  auth: authReducer,
})

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["test", "hazard", "auth"],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
})

export const persistor = persistStore(store)

export default { store, persistor }
